<ng-container [ngSwitch]="(pageStatus$ | async)?.statusCode">
  <a-forbidden *ngSwitchCase="STATUS_CODES.FORBIDDEN"></a-forbidden>
  <a-not-found *ngSwitchCase="STATUS_CODES.NOT_FOUND"></a-not-found>
  <a-no-connection *ngSwitchCase="STATUS_CODES.CONNECTION_PROBLEM"></a-no-connection>
  <a-front-error *ngSwitchCase="undefined"></a-front-error>
  <ng-content *ngSwitchCase="STATUS_CODES.OK"></ng-content>
  <a-server-error *ngSwitchDefault></a-server-error>
</ng-container>
